import React from 'react';
import { debounce } from 'lodash';

export function useWindowWidth() {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    const handleWindowResize = debounce(
      /* istanbul ignore next */ () => {
        setWindowWidth(window.innerWidth);
      },
      400,
    );

    window.addEventListener('resize', handleWindowResize);

    return /* istanbul ignore next */ () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  return windowWidth;
}
